import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import {
  FDBodyText, FDHeadlineText, FDImage, FDPaper, FDStack,
} from '@facet-wealth/design';
import { dataAttrs } from 'Helpers/Testing';
import MetaControl from 'Components/UI/Meta/MetaControl';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import React from 'react';
import useMobileLayout from 'Hooks/useMobileLayout';

const metaOverrides = buildFacetDesignOverride()
  .nameOverride('title', {
    _component: () => FDHeadlineText,
    _customProps: { size: 'lg' },
  }, overrideReadOnly)
  .nameOverride('subtitle', {
    _component: () => FDBodyText,
    _customProps: { size: 'lg' },
  }, overrideReadOnly);


export const TaxSavingsInRoadmapExplanationSectionLayout = ({
  resource,
}) => {
  const isMobile = useMobileLayout();

  return (
    <FDPaper
      appearance={'elevated'}
      maxWidth={725}
      alignSelf={'center'}
      {...dataAttrs('tax-strategy-detail-tax-savings-in-roadmap-explanation-section')}
    >
      <FDStack paddingX={4} paddingY={5} direction={'row'} spacing={8}>
        <FDStack
          direction={'column'}
          paddingX={(isMobile) ? 1 : 8}
          spacing={3}
          alignItems={'center'}
        >
          {resource.withRelationship(
            fr.relationships.icon.name,
            (rel) => (<FDImage
              alt={rel.meta('altText')}
              src={rel.link('related').url()}
              maxHeight={'48px'}
              rounded={false}
            />),
            () => null,
          )}
          <MetaControl resource={resource} metaOverrideSet={metaOverrides} attrName={'title'} align={(isMobile) ? 'start' : 'center'} />
          <MetaControl resource={resource} metaOverrideSet={metaOverrides} attrName={'subtitle'} align={(isMobile) ? 'start' : 'center'} />
        </FDStack>
      </FDStack>
    </FDPaper>
  );
};

TaxSavingsInRoadmapExplanationSectionLayout.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};
